import { render, staticRenderFns } from "./ColumnsWithIcons.vue?vue&type=template&id=21e8f80e&"
import script from "./ColumnsWithIcons.vue?vue&type=script&lang=js&"
export * from "./ColumnsWithIcons.vue?vue&type=script&lang=js&"
import style0 from "./ColumnsWithIcons.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports